<div class="form-group has-search inputField" style="display: none;" [class.show]="tabledata">
  <input [(ngModel)]="searchTerm" (ngModelChange)="search()" class="form-control form-control-search" placeholder="Suche"
    style="height: 38px;" />
  </div>

  <table mat-table style="display: none;" [class.show]="tabledata"
    [dataSource]="tabledata" class="table" multiTemplateDataRow
    matSort matSortDisableClear [trackBy]="trackByIndex">

    <ng-container matColumnDef="deviceType" sticky>
      <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Typ</th>
      <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
        <span>{{data.deviceType}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="serialNumber" sticky>
      <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Seriennummer</th>
      <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
        <span>{{data.serialNumber}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="deviceStatus" sticky>
      <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Gerätestatus</th>
      <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
        @if (data.deviceStatus == 0) {
          <span>-/-</span>
        }
        @if (data.deviceStatus == 1) {
          <span>Online</span>
        }
        @if (data.deviceStatus == 2) {
          <span>Offline</span>
        }
        @if (data.deviceStatus == 3) {
          <span>Warten</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="status" sticky>
      <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
        @if (data.status == 0) {
          <span>Ausstehend</span>
        }
        @if (data.status == 1) {
          <span>Wird heruntergeladen</span>
        }
        @if (data.status == 2) {
          <span>Erfolgreich</span>
        }
        @if (data.status == 3) {
          <span>Fehlgeschlagen</span>
        }
        @if (data.status == 4) {
          <span>Abgebrochen</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="lastUpdate" sticky>
      <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Letztes Aktualisierung</th>
      <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
        <span>{{data?.lastUpdated ? (data.lastUpdated | date:'dd.MM.yyyy HH:mm:ss') : ""}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="retryAttempts" sticky>
      <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Wiederholungen</th>
      <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
        <span>{{data.retryAttempts}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="errorMessage" sticky>
      <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header></th>
      <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
        @if (data.errorMessage) {
          <mat-icon
            ngbTooltip="{{data.errorMessage}}" container="body" tooltipClass="myTooltip" triggers="hover">
            error
          </mat-icon>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
    <tr mat-row *matRowDef="let data; columns: displayedColumns;"></tr>

  </table>
